import List from "@material-ui/core/List";
import { inject, observer } from "mobx-react";
import React from "react";
import { CommonsStore } from "../../model/CommonsStore";

interface SideMenuItemsProps {
  commons?: CommonsStore;
}

// deprecated
export const SideMenuItems = inject("commons")(
  observer(({ commons }: SideMenuItemsProps) => {
    return <List>{commons!.sideMenuItems}</List>;
  })
);
